<template>
    <el-container>
        跳转中..
    </el-container>
</template>

<script>
    export default {
        name: "telegramAuth",
        data() {
            return {
                web_token: '',
            }
        },
        mounted() {
          console.log(this.$route.query);
          const query=this.$route.query;
          this.web_token = query.web_token;
          this.path=query.path;
          this.login();

        },
        methods:{

            async login() {
                console.log('login');
                if(!this.web_token){
                  this.$message.error("token错误");
                  return;
                }
                let postdata = {
                    token: this.web_token
                };
                const {ret,data} = await this.$api.telegramAuth(postdata);
                if (ret === 1000){
                    this.$storeLocal.set('token',data.token);
                    this.$storeLocal.set('userInfo',data.user_info);
                    this.$store.state.token = data.token;
                    await this.$router.push(this.path);
                }else{

                  this.$message.error("登录错误");
                }
            },

        },
        components: {
        },
    }
</script>
